"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTokenPriceFromPair = void 0;
var bn_js_1 = __importDefault(require("bn.js"));
var react_1 = require("react");
var launchpadConstants_1 = require("../../launchpadConstants");
var utils_1 = require("../../shared/utils");
// TODO: check if need to swap "tokens" and "currency"
function useTokenPriceFromPair(_a) {
    var pairContract = _a.pairContract, _b = _a.tokenDecimals, tokenDecimals = _b === void 0 ? 18 : _b, _c = _a.intervalSec, intervalSec = _c === void 0 ? 300 : _c, _d = _a.isActive, isActive = _d === void 0 ? true : _d;
    var _e = (0, react_1.useState)(launchpadConstants_1.ZERO_BN), price = _e[0], setPrice = _e[1];
    (0, react_1.useEffect)(function () {
        if (!pairContract || !isActive)
            return;
        var update = function () {
            (0, utils_1.call)(pairContract, "getReserves")
                .then(function (_a) {
                var tokens = _a[0], currency = _a[1];
                var t = (0, utils_1.normalizeDecimals)(new bn_js_1.default(tokens), tokenDecimals);
                var c = new bn_js_1.default(currency);
                if (!t.eqn(0) && !c.eqn(0)) {
                    var price_1 = c.mul(launchpadConstants_1.DEC_NORM).div(t);
                    setPrice(price_1);
                    // debug("useTokenPriceFromPair", {
                    //   tokens: toEth(t),
                    //   currency: toEth(c),
                    //   price: toEth(price),
                    // });
                }
            })
                .catch(function (err) { return console.error("Error getReserves", err); });
        };
        update();
        var id = setInterval(update, intervalSec * 1000);
        return function () { return clearInterval(id); };
    }, [isActive, pairContract]);
    return price;
}
exports.useTokenPriceFromPair = useTokenPriceFromPair;
